import '../../style/index.less';
import './index.less';
import "../../style/nsky/reset/spin/index.less";



/** WEBPACK FOOTER **
 ** ./components/spin/style/index.js
 **/